import { gql } from 'graphql-tag';

const Mutations = {
    INGEST_DOCUMENTS: gql`
        mutation IngestDocuments($ingestionInput: IngestionDocsInput!) {
            ingestDocuments(ingestioninput: $ingestionInput) {
                __typename
            }
        }
    `,

    POST_QUESTION: gql`
        mutation PostQuestion(
            $embeddings_model: ModelConfiguration
            $jobid: ID
            $jobstatus: String  
            $presignedurl: String
            $verbose: Boolean
            $question: String
            $qa_model: ModelConfiguration
            $retrieval: RetrievalConfiguration
            $responseGenerationMethod: ResponseGenerationMethod
        ) {
            postQuestion(
                embeddings_model: $embeddings_model
                jobid: $jobid
                jobstatus: $jobstatus
                presignedurl: $presignedurl
                qa_model: $qa_model
                retrieval: $retrieval
                verbose: $verbose
                question: $question
                responseGenerationMethod: $responseGenerationMethod
            ) {
                __typename
            }
        }
    `,
};

export default Mutations;
